import { useEffect, useState } from "react";

export const useObjectUrl = (blob: Blob | undefined) => {
	const [url, setUrl] = useState<string>();

	useEffect(() => {
		if (!blob) {
			setUrl(undefined);
			return;
		}

		const objectUrl = URL.createObjectURL(blob);
		setUrl(objectUrl);

		return () => URL.revokeObjectURL(objectUrl);
	}, [blob]);

	return url;
};
